<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="icon"
    viewBox="0 0 40 40"
  >
    <path
      d="M21.4665 29.8004H18.5332V26.867H21.4665V29.8004Z"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.5332 20.0004C3.5332 10.9058 10.9053 3.53369 19.9999 3.53369C29.0944 3.53369 36.4665 10.9058 36.4665 20.0004C36.4665 29.0949 29.0944 36.467 19.9999 36.467C10.9053 36.467 3.5332 29.0949 3.5332 20.0004ZM33.5332 20.0004C33.5332 12.5382 27.462 6.46702 19.9999 6.46702C12.5377 6.46702 6.46654 12.5382 6.46654 20.0004C6.46654 27.4625 12.5377 33.5337 19.9999 33.5337C27.462 33.5337 33.5332 27.4625 33.5332 20.0004Z"
    />
    <path
      d="M21.4665 25H18.5332V11.0667H21.4665V25Z"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconError',
};
</script>

<style scoped>
.icon {
  display: inline-block;
  width: 1rem;
  height: 1rem;
  fill: inherit;
  flex-shrink: 0;
}
</style>
